import { connect } from 'react-redux';
import { ContactsWithWhatsAppExpandableProps, ContactsWithWhatsAppExpandable as ContactsWithWhatsAppExpandableUnconnected } from './contacts-with-whatsapp-expandable';
import withEvents from 'analytics/withEvents';
import { IUpdateUserProfileVariables, MutationType, PromotionPlanType, ISubmitLeadVariables } from 'store/sagas/apiService/types';
import { inlineMutate } from 'store/state/mutationsResponse/actions';
import { Dispatch } from 'react';
import { RootAction, State } from 'store/state';
import { IBulletinPrivate, POC, PocType, User } from 'utils/entities';
import { createSelector } from 'reselect';
import { userProfileFieldsSelector } from 'components/navigation/profileFields';
import { isConnectedUserSelector } from 'store/state/domainData/selectors';

const isLoggedInSelector = createSelector([ userProfileFieldsSelector, isConnectedUserSelector ], (userProfile, isConnectedUser) => {
  return isConnectedUser && userProfile && userProfile.initials;
});

const ContactsWithWhatsAppExpandableWithEvents = withEvents<ContactsWithWhatsAppExpandableProps>((sendEvent) => ({
  onWhatsAppFormOpen(poc: POC, phone: string) {
    sendEvent('property_lead_whatsapp_form_open', 'property', {
      event: {
        agent_details: {
          id: poc && poc.userId,
          phone_number: phone,
        },
      },
    });
  },
  onWhatsAppFormClose(poc: POC, phone: string) {
    sendEvent('property_lead_whatsapp_form_close', 'property', {
      event: {
        agent_details: {
          id: poc && poc.userId,
          phone_number: phone,
        },
      },
    });
  },
  onWhatsAppButtonClick(poc: POC, phone: string, user: User, contactPhone: string, plan?: PromotionPlanType) {
    const isPrivate = poc.type === PocType.Private;

    if (isPrivate) {
      sendEvent('property_lead_whatsapp_individual_click', 'property', {
        event: {
          user_details: {
            id: poc.userId,
            name: (poc as IBulletinPrivate).contactInfo && (poc as IBulletinPrivate).contactInfo.name,
            email: (poc as IBulletinPrivate).contactInfo && (poc as IBulletinPrivate).contactInfo.email,
            phone_number: phone,
            promotion_plan: plan ? plan.toLowerCase() : undefined,
          },
          contact_details: {
            first_name: user && user.firstName,
            surname: user && user.lastName,
            email: user && user.email,
            phone: contactPhone,
          },
        },
      });
    }
    else {
      sendEvent('property_lead_whatsapp_click', 'property', {
        event: {
          agent_details: {
            id: poc && poc.userId,
            phone_number: phone,
          },
          contact_details: {
            first_name: user && user.firstName,
            surname: user && user.lastName,
            email: user && user.email,
            phone: contactPhone,
          },
        },
      });
    }
  },
}))(ContactsWithWhatsAppExpandableUnconnected);

const mapStateToProps = (state: State) => ({
  isLoggedInUser: isLoggedInSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onUpdateUser: (data: Pick<IUpdateUserProfileVariables, 'phone'>) => dispatch(inlineMutate(MutationType.UpdateUserProfile, data)),
  onSubmitLead: (data: ISubmitLeadVariables) => dispatch(inlineMutate(MutationType.SubmitLead, data)),
});

const ConnectedContactsWithWhatsAppExpandable = connect(mapStateToProps, mapDispatchToProps)(ContactsWithWhatsAppExpandableWithEvents);

export default ConnectedContactsWithWhatsAppExpandable;
